

export default {
  namespaced: true,
  state: {
    drawer: null,
    color: 'general',
    image: '', // change if you want a picture but if you are using this internally get rid of the picture links here and in filter.vue
    selectedMenu: 'Home',
    selectedSubMenu:'',
    breadCrumbChilde:[],
    menus:[]
  },

  mutations: {
    setDrawer(state, drawer) {
      state.drawer = drawer;
    }
    ,
    onMenuSelected(state, data) {
      if (data) {
        state.selectedMenu = data.main;
        state.selectedSubMenu = data.sub;
      }

    },
    addBreadCrumbChilde(state,data)
    {
      if (data) {
        state.breadCrumbChilde = data
      }
    },
    setMenus(state,data){
      if (data) {
        state.menus = data
      }
    }
  },
  actions: {
    addBreadCrumbChilde(context, value) {
      context.commit("addBreadCrumbChilde", value);
    },
    setDrawer(context, value) {
      context.commit("setDrawer", value);
    },
    onMenuSelected(context, value) {
      context.commit("onMenuSelected", value);
    },
    setImage(context, value) {
      context.commit("setImage", value);
    },
    setColor(context, value) {
      context.commit("setColor", value);
    },
    toggleDrawer(context, value) {
      context.commit("toggleDrawer", value);
    },
    setMenus(context, value) {
      console.log(value);
      context.commit("setMenus", value);
    },
  }
};
